import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const currentPage = createReducer(0,{
  [types.SET_PAGE](state,action){
    return action.payload;
  }
})



// WEBPACK FOOTER //
// ./src/reducers/navigation.js